<mat-table *ngIf="zoningCode?.Versions" [dataSource]="zoningCode.Versions" class="mat-elevation-z16"
    style="width: 100%">
    <ng-container matColumnDef="{{ cell.property }}" *ngFor="let cell of zoningCodeVersionCells">
        <mat-header-cell *matHeaderCellDef> {{ cell.title }} </mat-header-cell>
        <mat-cell *matCellDef="let zcVersion" (click)="openZCVersionSideNav(zoningCode, zcVersion)">
            {{ zcVersion[cell.property] }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Actions">
        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
        <mat-cell *matCellDef="let zcVersion" class="actions-container"
            (click)="openZCVersionSideNav(zoningCode, zcVersion)">

            <app-zoning-code-version-calculate-with-settings-button *ngIf="showCalcButton" [zoningCode]="zoningCode"
                [zoningCodeVersion]="zcVersion" [stateEnv]="stateEnv">
            </app-zoning-code-version-calculate-with-settings-button>

            <app-zoning-code-version-recalculate-with-settings-button *ngIf="showReCalcButton" [zoningCode]="zoningCode"
                [zoningCodeVersion]="zcVersion" [stateEnv]="stateEnv">
            </app-zoning-code-version-recalculate-with-settings-button>

            <app-zoning-code-version-check-status-button *ngIf="showCheckStatusButton" [zoningCode]="zoningCode"
                [zoningCodeVersion]="zcVersion" [openDialog]="true" [isOpen]="isOpen" [isLoaded]="isLoaded"
                (isLoadedChange)="setIsLoaded($event)"
                (isLoadedVersionDialog)="setIsLoadedZCVersionDialog($event, zoningCode)" [stateEnv]="stateEnv">
            </app-zoning-code-version-check-status-button>

            <app-set-zc-version-last-updated-button [zoningCodeVersion]="zcVersion" *ngIf="showSetLastUpdateButton"
                [zoningCode]="zoningCode" [stateEnv]="stateEnv"></app-set-zc-version-last-updated-button>

            <app-zoning-code-version-delete-button *ngIf="showDeleteButton" [zoningCode]="zoningCode"
                [zoningCodeVersion]="zcVersion">
            </app-zoning-code-version-delete-button>

            <app-process-small-spinner class="zc-version-small-spinner" *ngIf="isLoadedZCVersionDialog"
                [isVisible]="zoningCode.isWaitingActionFinish">
            </app-process-small-spinner>
        </mat-cell>

    </ng-container>

    <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let zcVersion" class="actions-container">
            <ng-container *ngIf="!zcVersion.isDeleting; else removingInProgress">
                <app-task-view *ngFor="let task of zcVersion.Tasks" [task]="task" [showTaskTabButton]="true">
                </app-task-view>
            </ng-container>

            <ng-template #removingInProgress>
                Removing in progress
            </ng-template>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="MissedEntities">
        <mat-header-cell *matHeaderCellDef>Missed Entities</mat-header-cell>
        <mat-cell *matCellDef="let zcVersion"><app-missed-entities-details-icon
                [missedEntitiesData]="zcVersion?.MetaData">
            </app-missed-entities-details-icon></mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="zoningCodeVersionColumnsToDisplay">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: zoningCodeVersionColumnsToDisplay" class="expanded-detail-row">
    </mat-row>
</mat-table>
